var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRootFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 15.8333C18.3334 16.2754 18.1578 16.6993 17.8453 17.0118C17.5327 17.3244 17.1088 17.5 16.6667 17.5H3.33341C2.89139 17.5 2.46746 17.3244 2.1549 17.0118C1.84234 16.6993 1.66675 16.2754 1.66675 15.8333V4.16667C1.66675 3.72464 1.84234 3.30072 2.1549 2.98816C2.46746 2.67559 2.89139 2.5 3.33341 2.5H7.50008L9.16675 5H16.6667C17.1088 5 17.5327 5.17559 17.8453 5.48816C18.1578 5.80072 18.3334 6.22464 18.3334 6.66667V15.8333Z",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13439_33682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66659 14V13.3333C9.66659 12.9797 9.52611 12.6406 9.27606 12.3905C9.02601 12.1405 8.68687 12 8.33325 12H5.66659C5.31296 12 4.97382 12.1405 4.72378 12.3905C4.47373 12.6406 4.33325 12.9797 4.33325 13.3333V14",
    stroke: "#94a3b8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 10.6667C7.73646 10.6667 8.33341 10.0697 8.33341 9.33333C8.33341 8.59695 7.73646 8 7.00008 8C6.2637 8 5.66675 8.59695 5.66675 9.33333C5.66675 10.0697 6.2637 10.6667 7.00008 10.6667Z",
    stroke: "#94a3b8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13439_33682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(3 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootFolder);
export default __webpack_public_path__ + "static/media/root-folder.c4becee43b20c573d856f7e703ddd0a7.svg";
export { ForwardRef as ReactComponent };